// Tiny toast queue. The imperative `toast.*` API exists so non-React code
// (terminalManager, API callbacks) can fire notifications; ToastHost renders
// whatever is in the store.

import { create } from 'zustand';

export type ToastKind = 'success' | 'error' | 'info';

export interface Toast {
    id: number;
    kind: ToastKind;
    message: string;
}

interface ToastStore {
    toasts: Toast[];
    dismiss: (id: number) => void;
}

const DEFAULT_DURATION = 4000;

let nextId = 1;

export const useToasts = create<ToastStore>((set) => ({
    toasts: [],
    dismiss: (id) =>
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

function push(kind: ToastKind, message: string, opts?: { duration?: number }) {
    const id = nextId++;
    useToasts.setState((s) => ({ toasts: [...s.toasts, { id, kind, message }] }));
    setTimeout(
        () => useToasts.getState().dismiss(id),
        opts?.duration ?? DEFAULT_DURATION,
    );
}

export const toast = {
    success: (message: string, opts?: { duration?: number }) =>
        push('success', message, opts),
    error: (message: string, opts?: { duration?: number }) =>
        push('error', message, opts),
    info: (message: string, opts?: { duration?: number }) =>
        push('info', message, opts),
};
